import { DefaultPalette } from '/druid/colors/index';
import { DefaultEffects } from '/druid/effects/index';
import { DefaultFontStyles } from '/druid/fonts/index';
import { mergeThemes } from '/druid/mergeThemes';
import { DefaultSpacing } from '/druid/spacing/index';
import { PartialTheme, Theme } from '/druid/types/index';
import { makeSemanticColors } from '/druid/utilities/makeSemanticColors';

/**
 * Creates a custom theme definition.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */
export function createTheme(theme: PartialTheme = {}, depComments: boolean = false): Theme {
  const isInverted = !!theme.isInverted;
  const baseTheme: Theme = {
    palette: DefaultPalette,
    effects: DefaultEffects,
    fonts: DefaultFontStyles,
    spacing: DefaultSpacing,
    isInverted,
    disableGlobalClassNames: false,
    semanticColors: makeSemanticColors(DefaultPalette, DefaultEffects, undefined, isInverted, depComments),
    rtl: undefined,
  };

  return mergeThemes(baseTheme, theme);
}
